<template>
  <div id="order-view">
    <div class="order-view-header">
      <h1>{{$_('my_orders')}}</h1>
      <p>{{$_('orders_page_text')}}</p>
    </div>
    <OrderResearch @orderresearch:search="vSearchEvent"/>
    <OrderList />
  </div>
</template>

<script>
import OrderResearch from "../components/OrderResearch";
import OrderList from "../components/OrderList";

export default {
  components: {
    OrderResearch,
    OrderList
  },
  methods: {
    vSearchEvent() {
      console.error(this.$store.getters['commande/get_fref']);
    }
  }
};
</script>

<style scoped>

.order-view-header {
  padding: 30px;
}

</style>